export enum MatchParticipantStatus {
  SignedUp,
  CheckedIn,
  Active,
}
